import { LegalLayout } from "@/components/LegalLayout";
import { useLang } from "@/i18n/LanguageContext";

export default function Terms() {
  const { t } = useLang();
  return <LegalLayout doc={t.legal.terms} testId="terms-page" />;
}
